<template>
  <b-card   style="height:100%; " class="card-company-table">
    <b-card-header  class="p-0 pb-2 ">
      <b-card-title >آخرین کاربران ها</b-card-title>
    </b-card-header>

    <data-table
      :fields="fields"
      :items="activeUsers"
      :loading="loading"
      
    >
    <!-- selectable
      @rowSelected="
        $router.push({ name: 'show-course', params: { id: $event[0].id } })
      " -->

      <template #fullName="{ data }">{{ data.item.fullName }}</template>
      <template #courses="{ data }">
        <b-button
          variant="flat-info"
          class="btn-icon"
          :id="'hover-course-' + data.item.id"
        >
          <feather-icon size="20" icon="InfoIcon" />
        </b-button>
        <b-popover :target="'hover-course-' + data.item.id" triggers="hover"  variant="info">
          <template #title> دوره ها</template>
          <div
            class="d-flex justify-content-between my-1"
            v-for="(course, index) in data.item.courses"
            :key="index"
          >
            <span class="mx-3">{{ course.name }}</span>
          </div>
        </b-popover></template
      >
      <template #penalties="{ data }"
        ><b-button
          variant="flat-danger"
          class="btn-icon"
          :id="'hover-penalty-' + data.item.id"
        >
          <feather-icon size="20" icon="InfoIcon" />
        </b-button>
        <b-popover :target="'hover-penalty-' + data.item.id" triggers="hover"  variant="danger">
          <template #title > جریمه ها</template>
          <div
            class="d-flex justify-content-between my-1"
            v-for="(penalty, index) in data.item.penalties"
            :key="index"
          >
            <span class="mx-3">{{ penalty.name }}</span>
          </div>
        </b-popover></template
      >
      <template #correctAnswers_count="{ data }">{{
        data.item.correctAnswers_count
      }}</template>

      <template #progressPercentage="{ data }"
        >{{ data.item.progressPercentage }} %
        <feather-icon
          :icon="
            data.item.progressPercentage > 40
              ? 'TrendingDownIcon'
              : 'TrendingUpIcon'
          "
          :class="
            data.item.progressPercentage > 40 ? 'text-danger' : 'text-success'
          "
        />
      </template>
    </data-table>
    <div class="w-100">
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        size="md"
        class="my-2 d-flex justify-content-center"
      ></b-pagination>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BTable,
  BAvatar,
  BImg,
  BProgress,
  BButton,
  BFormFile,
  BModal,
  VBModal,
  BPopover,
  BBadge,
  BPagination,
  BCardHeader,
  BCardTitle,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BImg,
    BProgress,
    BButton,
    BFormFile,
    BModal,
    VBModal,
    BPopover,
    BBadge,
    BPagination,
    DataTable,
  BCardHeader,
  BCardTitle,
  },
  props: {
    activeUsers: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
       currentPage: 1,
      totalRows: 4,
      perPage: 2,
      fields: [
        { key: "fullName", label: "نام کاربر" },
        { key: "courses", label: "دوره ها" },
        { key: "penalties", label: "جریمه ها" },
        { key: "correctAnswers_count", label: "تعداد جواب درست" },
        { key: "progressPercentage", label: "درصد پیشرفت" },
      ],
    };
  },
};
</script>
